export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/quote.svg'
